import { ServiceModelType } from "@/@types/types";
import { Layout } from "@/components/Layout";
import React from "react";
import { PortfolioFilters } from "../Portfolio/portfolio-filters";
import SEO, { SEOType } from "../SEO";
import { Breadcrumb } from "../Shared/Breadcrumb";
import { ServiceCard } from "./service-card";

interface ServicesListProps {
  services: ServiceModelType[];
  seo: SEOType;
}

interface ServicesListState {
  activeFilter: string;
  categories: string[];
}

export default class ServicesList extends React.Component<ServicesListProps, ServicesListState> {
  constructor(props: ServicesListProps) {
    super(props);
    this.state = {
      activeFilter: "All Services",
      categories: this.collectCategories(props.services),
    };
  }

  collectCategories(services: ServiceModelType[]): string[] {
    const priorityOrder = [
      "AI Solutions",
      "Mobile App",
      "Web App",
      "IT Consultation",
      "TV App",
      "Games",
      "Digital Marketing",
    ];

    const cats = new Set<string>();
    services.forEach((s) => {
      if (s.category) {
        cats.add(s.category);
      }
    });

    const sortedCats = Array.from(cats).sort((a, b) => {
      const indexA = priorityOrder.indexOf(a);
      const indexB = priorityOrder.indexOf(b);

      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;

      return a.localeCompare(b);
    });

    return ["All Services", ...sortedCats];
  }

  handleFilterChange: (filter: string) => void = (filter: string) => {
    this.setState({ activeFilter: filter });
  };

  render(): JSX.Element {
    const { services, seo } = this.props;
    const { activeFilter, categories } = this.state;

    const filteredServices =
      activeFilter === "All Services"
        ? services
        : services.filter((s) => s.category === activeFilter);

    return (
      <Layout>
        <SEO contentfulSeo={seo} />
        <Breadcrumb
          currentPageTitle="Services"
          routes={[
            { path: "/", title: "Home" },
            { path: "/services/", title: "Services" },
          ]}
        />
        <div className="page-bottom pbottom-70 pt-4">
          <div className="container">
            <PortfolioFilters
              filters={categories}
              activeFilter={activeFilter}
              onFilterChange={this.handleFilterChange}
            />
            <div className="row">
              {filteredServices.map(
                ({ icon, serviceDescription, serviceTitle, slug, id, category }) => {
                  return (
                    <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={id}>
                      <ServiceCard
                        description={serviceDescription}
                        icon={icon}
                        category={category}
                        title={serviceTitle}
                        routerLink={"/" + slug}
                      />
                    </div>
                  );
                },
              )}
            </div>
            {filteredServices.length === 0 && (
              <div className="text-center w-100 py-5">
                <p>No services found in this category.</p>
              </div>
            )}
          </div>
        </div>
      </Layout>
    );
  }
}
